var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TreeSelect',{attrs:{"placeholder":_vm.placeholder,"value":_vm.value,"data":_vm.list,"multiple":true,"normalizer":_vm.normalizer,"value-consists-of":"LEAF_PRIORITY"},on:{"input":_vm.handleInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }